<template>
	<div class="wrap">
		<div style="display: flex;justify-content: space-between;margin-top: 50px;height:800px;">
			<div class="files">
				<!-- <div v-for="(item,index) in filesList" :key="index">
					{{item.name}}
				</div> -->
				<div @click="$router.go(-1)">
					返回
				</div>
			</div>
			<!-- <el-card class="box-card">
			 <div v-for="(item,index) in filesList" :key="index">
			 	{{item.name}}
			 </div>
			</el-card> -->
			<div class="editor">
				<div class="form-item">
					<div style="display: flex;align-items: center;">
						<div class="jtitle">
							<span style="color: red;"></span> 标题：
						</div>
						<div class="inpt">
							<el-input style="width: 450%;height: 100%;" v-model="title" type="text"
								placeholder="请输入标题" show-word-limit></el-input>
						</div>
					</div>
				</div>
				<div id="vditor" name="description">

				</div>
				<div class="btns">
					<div @click="handleBack">返回</div>
					<div @click='save'>保存</div>
					<div @click="toMarkdownSave">保存为版本</div>
					<div @click="toMarkdownSave(1)">确认并返回</div>
				</div>

			</div>
			<div class="history">
				<div v-for="(item,i) in historyList" :key="item.id" @click='setValue(item)'>
					<p :class="item.id==$store.state.releaseInfo[index].id?'active':''">版本{{i+1}}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vditor from 'vditor'
	import base_url from '../../common/URL.js'
	import "vditor/src/assets/less/index.less"
	let that
	export default {
		data() {
			return {
				editor: "",
				contentEditor: '',
				historyList: [],
				templateData: '',
				info: {

				},
				releaseId: '',
				index: '',
				title: '', // 用于绑定标题输入框的值
			}
		},

		created() {
			this.setDefaultTitle();
			this.showLoading();
			this.index = this.$route.query.index
			if (this.index == 0) {
				this.info.index = 0
				this.getTemplateDetail(this.$store.state.releaseInfo[0].id)
			} else if (this.index == 1) {
				this.info.index = 1
				this.getTemplateDetail(this.$store.state.releaseInfo[1].id)
			} else if (this.index == 2) {
				this.info.index = 2
				this.getTemplateDetail(this.$store.state.releaseInfo[2].id)
			}
			that = this
		},
		mounted() {
			this.contentEditor = new Vditor("vditor", {
				mode: 'wysiwyg',
				height: 650,
				width: 920,
				toolbarConfig: {
					pin: true,
				},
				// outline:{
				// 	enable:true,
				// },
				upload: {
					url: this.uploadPath + '/common/upload',
					accept: 'image/jpeg,image/png,image/gif,image/jpg,image/bmp', // 图片格式
					headers: {
						token: this.$store.state.userInfo.token
					},
					fieldName: "file",
					success(_, msg) {
						let data = JSON.parse(msg)
						let url = base_url + data.data.url
						that.contentEditor.insertValue(`![](${url})`)
					}
				},
				cache: {
					enable: false
				},
				preview: {

				},
				after: () => {
					this.hideLoading();
				}
			})
		},
		methods: {
			handleBack() {
			      if (confirm('返回现有的编辑将不会被保存，确定要不保存直接返回吗？')) {
			        this.$router.go(-1);
			      }
			},
			setDefaultTitle() {
			      const now = new Date();
			      const formattedDate = now.toLocaleString(); // 根据需要格式化日期时间
			      this.title = formattedDate;
			},
			replaceSubstring(str, substring) {
				return str.replace(substring, '');
			},
			getTemplateDetail(id) {
				this.$api.markdownGetInfo({
					id: id
				}).then(res => {
					console.log(res);
					this.templateData = res.data.content
					console.log(res.data.content);
					this.contentEditor.setValue(this.templateData)
					this.info.id = res.data.id
					if (res.data.first_id) {
						this.releaseId = res.data.first_id
						this.templateHistoryList(res.data.first_id)
					} else {
						this.releaseId = res.data.id
						this.templateHistoryList(res.data.id)
					}
				})
			},
			async templateHistoryList(id) {
				const histroy = await this.$api.templateHistoryList({
					first_id: id,
				})
				this.historyList = histroy.data

			},
			async save() {
				const html = this.contentEditor.getHTML()
				const edit = await this.$api.markdownEdit({
					id: this.info.id,
					content: html,
				})
				console.log(edit);
				this.templateHistoryList(this.releaseId)
			},
			async toMarkdownSave(type) {
				const html = this.contentEditor.getHTML()
				let guolv = this.replaceSubstring(html, base_url)
				const md = await this.$api.markdownSave({
					title: this.title, // 传递标题
					content: guolv,
					first_id: this.releaseId
				})
				if (md.code == 1) {
					this.$message({
						message: md.msg,
						type: 'success'
					})
					md.data.first_id == 0 ? this.releaseId = md.data.id : this.releaseId = md.data.first_id
					this.templateHistoryList(this.releaseId)
					this.info.first_id = md.data.first_id
					this.info.id = md.data.id
					console.log(this.info);
					if (this.index == 0) {
						this.$store.commit('set_releaseInfo', this.info)
					} else if (this.index == 1) {
						this.$store.commit('set_releaseInfo', this.info)
					} else if (this.index == 2) {
						this.$store.commit('set_releaseInfo', this.info)
					}
					if (type == 1) {
						this.$router.go(-1)
					}
				} else {
					this.$message({
						message: md.msg,
						type: 'warning'
					})
				}


			},
			setValue(item) {
				this.info.id = item.id
				this.$store.commit('set_releaseInfo', this.info)
				this.contentEditor.setValue(item.content)
			}
		}
	}
</script>
<style>
	.box-card::-webkit-scrollbar-thumb {
		display: none;
	}

	.box-card {
		max-height: 300px;
		width: 200px;
		font-size: 18px;
		overflow: scroll;


	}
</style>
<style scoped lang="less">
	.active {
		color: #fff;
	}

	.btns {
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;

		&>div {
			width: 120px;
			height: 40px;
			margin-right: 15px;
			color: #fff;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
			border-radius: 10px;
			background: #0052d9;
		}
	}

	.history {
		width: 200px;
		overflow: auto;
		max-height: 500px;
		font-size: 18px;
		text-align: center;

		&>div {
			cursor: pointer;
			background: #e6e6e6;
			border-bottom: 1px solid #eee;
			color: #222;
			width: 98%;
			font-size: 16px;
			height: 35px;
			line-height: 35px;
		}

		&>div:hover {
			color: #0052d9;
		}

		&::-webkit-scrollbar {
			width: 4px;
			/*  设置纵轴（y轴）轴滚动条 */
			height: 4px;
			/*  设置横轴（x轴）轴滚动条 */
		}

		/* 滚动条滑块（里面小方块） */
		&::-webkit-scrollbar-thumb {
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(86, 86, 86, 0.2);
			background: rgba(61, 61, 61, 0.9);
		}

		/* 滚动条轨道 */
		&::-webkit-scrollbar-track {
			border-radius: 0;
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		}

	}

	.files {
		width: 200px;
		overflow: auto;
		max-height: 500px;
		font-size: 18px;
		text-align: center;

		&>div {
			cursor: pointer;
			line-height: 50px;
			width: 98%;
			border: 1px solid #e6e6e6;
			height: 50px;
		}

		&>div:hover {
			color: #0052d9;
		}
	}

	.files::-webkit-scrollbar {
		width: 4px;
		/*  设置纵轴（y轴）轴滚动条 */
		height: 4px;
		/*  设置横轴（x轴）轴滚动条 */
		position: relative;
		z-index: 9;

	}

	/* 滚动条滑块（里面小方块） */
	.files::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(86, 86, 86, 0.2);
		background: rgba(61, 61, 61, 0.9);
	}

	/* 滚动条轨道 */
	.files::-webkit-scrollbar-track {
		border-radius: 0;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	}

	.editor {
		width: 900px;
	}
</style>